/** @format */

import { createAction, props } from '@ngrx/store';
import { AvailableWarrantiesResponse, SelectedWarranty } from '@pdp/data-access/interfaces';

export const getAllWarranties = createAction('[Warranties] Get all warranties from API in effect');

export const getAllWarrantiesSuccess = createAction(
	'[Warranties] Get all warranties call success',
	props<{
		availableWarrantiesResponse: AvailableWarrantiesResponse;
	}>()
);

export const getAllWarrantiesError = createAction('[Warranties] Get all warranties call error');

export const selectWarranty = createAction(
	'[Warranties] Select warranty handled in effect',
	props<{
		selectedPlanSku: number | null;
	}>()
);

export const setSelectedWarranty = createAction(
	'[Warranties] Set selected warranty',
	props<{
		selectedWarranty: SelectedWarranty;
	}>()
);
